module.exports = __webpack_public_path__ + "img/selected7-min.435ec251.png";